import { Environment, EnvironmentMapping } from 'utils/Enums';

type ConfigModule = { config: any };

// export function getCustomerConfig() {
//     const configMap: Record<string, () => ConfigModule> = {
//         kind_staging: () => require('./customers/kind/kind_staging'),
//         kind_prod: () => require('./customers/kind/kind_staging'),
//         kind_test: () => require('./customers/kind/kind_staging'),
//         kind_dev: () => require('./customers/kind/kind_staging'),
//         truFru_staging: () => require('./customers/truFru/truFru_staging'),
//         truFru_prod: () => require('./customers/truFru/truFru_staging'),
//         truFru_test: () => require('./customers/truFru/truFru_staging'),
//         truFru_dev: () => require('./customers/truFru/truFru_staging'),
//         perrigo_staging: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_prod: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_test: () => require('./customers/perrigo/perrigo_staging'),
//         perrigo_dev: () => require('./customers/perrigo/perrigo_staging'),
//         constellation_staging: () => require('./customers/constellation/constellation_staging'),
//         constellation_prod: () => require('./customers/constellation/constellation_staging'),
//         constellation_test: () => require('./customers/constellation/constellation_staging'),
//         constellation_dev: () => require('./customers/constellation/constellation_staging'),
//         demo_staging: () => require('./customers/demo/demo_staging'),
//         demo_prod: () => require('./customers/demo/demo_staging'),
//         demo_test: () => require('./customers/demo/demo_staging'),
//         demo_dev: () => require('./customers/demo/demo_staging'),
//         naturesBakery_staging: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_prod: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_test: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         naturesBakery_dev: () => require('./customers/naturesBakery/naturesBakery_staging'),
//         gp_staging: () => require('./customers/gp/gp_staging'),
//         gp_prod: () => require('./customers/gp/gp_staging'),
//         gp_test: () => require('./customers/gp/gp_staging'),
//         gp_dev: () => require('./customers/gp/gp_staging'),
//         nomadFoods_staging: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_prod: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_test: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         nomadFoods_dev: () => require('./customers/nomadFoods/nomadFoods_staging'),
//         perrigoSpain_staging: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_prod: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_test: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoSpain_dev: () => require('./customers/perrigoSpain/perrigoSpain_staging'),
//         perrigoBelgium_staging: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_prod: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_test: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         perrigoBelgium_dev: () => require('./customers/perrigoBelgium/perrigoBelgium_staging'),
//         cooper_staging: () => require('./customers/cooper/cooper_staging'),
//         cooper_prod: () => require('./customers/cooper/cooper_staging'),
//         cooper_test: () => require('./customers/cooper/cooper_staging'),
//         cooper_dev: () => require('./customers/cooper/cooper_staging'),
//     };
//     const customerEnv = process.env.REACT_APP_CUSTOMER_ENV || 'staging';
//     const key = `${process.env.REACT_APP_TENANT_ID}_${customerEnv}`;

//     const loader = configMap[key];

//     if (!loader) {
//         throw new Error(`Unknown tenant/env: ${key}`);
//     }

//     return loader().config;
// }

export async function getCustomerConfig() {
    let mappedEnv;
    const tenant = process.env.REACT_APP_TENANT_ID || '';
    const env = process.env.REACT_APP_CUSTOMER_ENV || Environment.staging;
    // Global fallback when tenant/env is missing or points to a non-existent customer config module.
    const defaultTenant = 'demo';
    const defaultEnv = Environment.staging;
    const availableTenants = new Set([
        'kind',
        'truFru',
        'perrigo',
        'constellation',
        'demo',
        'naturesBakery',
        'gp',
        'nomadFoods',
        'perrigoSpain',
        'perrigoBelgium',
        'cooper',
    ]);

    // Only selected tenants have explicit prod config files.
    const prodEnabledCustomers: string[] = ['constellation'];
    if (prodEnabledCustomers.includes(tenant) && env === Environment.prod) {
        mappedEnv = Environment.prod;
    } else {
        mappedEnv = EnvironmentMapping?.[env as keyof typeof EnvironmentMapping] || Environment.staging;
    }

    const loadConfig = async (targetTenant: string, targetEnv: string) =>
        import(
            /* webpackChunkName: "customer-config-[request]" */
            `./customers/${targetTenant}/${targetTenant}_${targetEnv}`
        );

    // If tenant folder does not exist (e.g. sauerBrands), directly switch to default tenant.
    const tenantToLoad = tenant && availableTenants.has(tenant) ? tenant : defaultTenant;
    // Resolution order:
    // 1) requested tenant + mapped env
    // 2) requested tenant + staging
    // 3) default tenant + staging
    const candidates: Array<{ targetTenant: string; targetEnv: string }> = [
        { targetTenant: tenantToLoad, targetEnv: mappedEnv },
        { targetTenant: tenantToLoad, targetEnv: Environment.staging },
        { targetTenant: defaultTenant, targetEnv: defaultEnv },
    ];

    let lastError: unknown;
    const attempted = new Set<string>();
    for (const candidate of candidates) {
        const key = `${candidate.targetTenant}_${candidate.targetEnv}`;
        if (attempted.has(key)) continue;
        attempted.add(key);
        try {
            const module = await loadConfig(candidate.targetTenant, candidate.targetEnv);
            return module.config;
        } catch (error) {
            lastError = error;
        }
    }

    throw lastError;
}
